import React from 'react';
import { Slide } from '../ReportComponents';
import {
  Avatar,
  Box,
  Typography,
  Card,
  CardActionArea,
  CardContent
} from '@mui/material';
import { styled } from '@mui/system';
import { Link } from 'react-router-dom';

/**
 * Card with a modern glass-like background.
 */
const InfluencerCard = styled(Card)(({ theme }) => ({
  background: 'rgba(255,255,255,0.15)',
  backdropFilter: 'blur(8px)',
  borderRadius: theme.shape.borderRadius,
  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: `0 8px 20px rgba(0,0,0,0.2)`,
  },
}));

const InfluencerRow = ({ influencer }) => {
  return (
    <InfluencerCard elevation={0}>
      <CardActionArea component={Link} to={`/creators/${influencer.creator}`}>
        <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Avatar
            sx={{ width: 56, height: 56 }}
            src={influencer.pfphref}
            alt={influencer.creator}
          />
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              {influencer.creator}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {influencer.total_following.toLocaleString()} Followers
            </Typography>
          </Box>
        </CardContent>
      </CardActionArea>
    </InfluencerCard>
  );
};

export default function InfluencersSlide({ index, currentSlide, report }) {
  return (
    <Slide
      id="slide-influencers"
      index={index}
      currentIndex={currentSlide}
      sx={(theme) => ({
        background: `linear-gradient(135deg, #450af5, rgb(65, 95, 112))`,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: theme.spacing(4),
        padding: theme.spacing(4, 2),
      })}
    >
      <Typography
        variant="h5"
        sx={{
          color: '#fff',
          fontSize: 'clamp(1.3rem, 5vw, 2rem)',
          fontWeight: 700,
        }}
      >
        Creator Highlights
      </Typography>

      <Box sx={{ width: '100%', maxWidth: 420, margin: '0 auto', display: 'grid', gap: 2 }}>
        {report?.report.creator_videos
          .slice(0, 3)
          .map((influencer, idx) => (
            <InfluencerRow key={idx} influencer={influencer} />
          ))}
      </Box>

      <Typography variant="subtitle2" color="text.secondary">
        {report?.name}
      </Typography>
    </Slide>
  );
}
